import React, { useState, useEffect, useRef } from 'react';
import './Footer.css'
import { GoDotFill } from "react-icons/go";
import LegalDoc from '../../../RegistrationCommponents/LegalDoc';
import { Button } from 'antd';
import Support from '../Support';

const Footer = () => {
  const [legalDocVisible, setLegalDocVisible] = useState(false);
  const [legalDocType, setLegalDocType] = useState('');
  const [showSupport, setShowSupport] = useState(false);

  const supportRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (supportRef.current && !supportRef.current.contains(event.target)) {
        setShowSupport(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [supportRef]);

  return (
    <footer className="footer">
      <Support />
      <div className='footer-contents'>
        <div>&copy; {(new Date().getFullYear())} BreatheEV, Inc</div>
        <div>
          <Button onClick={() => { setLegalDocType('terms-of-service'); setLegalDocVisible(true); }} style={{ paddingLeft: 2, paddingRight: 2 }} type="link"><GoDotFill /> Terms of Use</Button>
          <Button onClick={() => { setLegalDocType('privacy-policy'); setLegalDocVisible(true); }} style={{ paddingLeft: 2, paddingRight: 2 }} type="link"><GoDotFill />Privacy Notice</Button>
          <LegalDoc type={legalDocType} modalVisible={legalDocVisible} closeModal={() => { setLegalDocVisible(false); }} />
        </div>
      </div>
    </footer>
  );
};

export default Footer;
